import { Registry } from "../registry/registry";
import { Website } from "../website-builder/wedding";

export abstract class BaseWebsiteTemplate {
    abstract updateWebsiteModal(website: Website): void;
    abstract updateRegistryModal(registry: Registry): void;
    abstract changeLang(): void;
    super() {}
  }

  


// WEBPACK FOOTER //
// ./src/app/website/template-base.ts